import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { getActionsModel } from '../../../../services/roles/projMilestoneRoleStatus';
import TableAction from '../../../strategyProject/tabs/TabResults/TableAction/TableAction';

// кнопки согласования отображаются только в реестре СП/политики, кнопка отправки - только в реестре проекта, кнопка редактирования - везде
export function MilestoneActions({
  props, actions, userCtx, navCtx, ...rest
}) {
  const {
    id, status,
  } = props;
  const can = useMemo(() => getActionsModel(status, userCtx, navCtx.stratId, navCtx.portfolioId, navCtx.projId, navCtx.policyId), [status, userCtx, props, navCtx]);
  const isTableActionEnabled = useMemo(() => (can.Send || can.Edit || can.Approve), [can]);

  return isTableActionEnabled ? (
    <TableAction>
      <div className="d-flex flex-column gap-3">
        <Button
          disabled={!can.Edit}
          style={{ fontWeight: 700 }}
          onClick={() => actions.edit(id, props)}
        >
          { props?.result ? 'Редактировать' : 'Заполнить факт' }
        </Button>
        {props.publishInMedia && can.Send && (
          <Button
            style={{ fontWeight: 700 }}
            variant="outline-warning"
            onClick={() => actions.send(id, props)}
          >
            Отправить на согласование
          </Button>
        )}
        {can.Approve && (
          <Button
            style={{ fontWeight: 700 }}
            variant="outline-success"
            onClick={() => actions.approve(id, props)}
          >
            Согласовать
          </Button>
        )}
        {can.Approve && (
          <Button
            style={{ fontWeight: 700 }}
            variant="outline-danger"
            onClick={() => actions.reject(id, props)}
          >
            Не согласовать
          </Button>
        )}
      </div>
    </TableAction>
  ) : (<></>);
}
